import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHero from "@/components/PageHero";
import { T } from "@/constants/testIds";

const CATEGORIES = [
  { slug: null, label: "All" },
  { slug: "gospel", label: "Gospel" },
  { slug: "doctrine", label: "Doctrine" },
  { slug: "apologetics", label: "Apologetics" },
  { slug: "christian-living", label: "Christian Living" },
];

export default function ArticlesIndex() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState(null);

  useEffect(() => {
    const url = cat ? `/articles?category=${cat}&limit=60` : "/articles?limit=60";
    api.get(url).then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [cat]);

  return (
    <>
      <PageHero
        eyebrow="The library"
        title="Articles"
        subtitle="Carefully written, editorially reviewed reflections on the Bible, the Gospel, and the Christian life."
      />
      <section className="py-16 sm:py-24">
        <div className="container-editorial">
          <div className="flex flex-wrap gap-2 mb-12">
            {CATEGORIES.map((c) => (
              <button
                key={c.label}
                data-testid={`articles-filter-${c.slug || "all"}`}
                onClick={() => setCat(c.slug)}
                className={`px-4 py-2 text-xs uppercase tracking-widest border transition-colors ${
                  cat === c.slug
                    ? "bg-ink text-background border-ink"
                    : "border-border text-ink-muted hover:border-ink hover:text-ink"
                }`}
              >
                {c.label}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {items.map((a) => (
              <Link
                key={a.id}
                to={`/articles/${a.slug}`}
                data-testid={T.articleCard(a.slug)}
                className="group flex flex-col"
              >
                <div className="flex items-center gap-3 text-[11px] uppercase tracking-widest text-ink-muted">
                  <span className="text-forest">{a.category}</span>
                  <span className="h-1 w-1 rounded-full bg-ink-muted/40" />
                  <span>{a.reading_time_min} min</span>
                </div>
                <h3 className="font-serif text-2xl mt-3 text-ink leading-snug group-hover:text-forest transition-colors" style={{ fontWeight: 500 }}>
                  {a.title}
                </h3>
                <p className="text-[15px] mt-4 text-ink-muted leading-relaxed">{a.summary}</p>
                <div className="mt-4 pt-4 border-t border-border text-xs text-ink-muted">By {a.author_name}</div>
              </Link>
            ))}
            {items.length === 0 && <p className="text-ink-muted">No articles in this category yet.</p>}
          </div>
        </div>
      </section>
    </>
  );
}
